module.exports = __webpack_public_path__ + "img/Guadeloupe.80dda247.png";